var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('b-alert',{attrs:{"variant":"danger","show":_vm.updateAlert>0}},[_vm._v(" "+_vm._s(_vm.formError)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }